<template>
  <canvas v-show="ready" id="totalVariety" ref="totalVariety" width="400" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

const CHART_COLORS = {
  blue: "rgb(54, 162, 235)",
  purple: "rgb(153, 102, 255)",
  green: "rgb(75, 192, 192)",
  yellow: "rgb(255, 205, 86)",
  orange: "rgb(255, 159, 64)",
  red: "rgb(255, 99, 132)",
  grey: "rgb(201, 203, 207)"
};

export default {
  props: ["client_customer", "product", "product_type"],
  data() {
    return {
      ready: false,
      labels: [],
      data: [
        {
          label: "Kg",
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          borderWidth: 1,
          datalabels: {
            // anchor: "start",
            formatter: function (value, context) {
              return new Intl.NumberFormat("es-CL").format(value) + " Kg";
            }
          }
        }
      ]
    };
  },
  async mounted() {
    const self = this;
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/stock/stock_by_condition?client_customer=${this.client_customer}&product=${this.product}&product_type=${this.product_type}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.labels = response.data.labels;
      this.data[0].data = response.data.dataset;
      this.ready = true;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }

    this.ready = true;

    let ctx = this.$refs.totalVariety.getContext("2d");
    const myChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: this.labels,
        datasets: this.data
      },
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "right"
          },
          datalabels: {
            color: "#043e73"
          },
          title: {
            display: true,
            align: "start",
            text: "Total kilos por condición"
          }
        },
        animation: {
          onComplete: function (animation) {
            setTimeout(() => {
              self.$emit("chart-ready");
            }, 500);
          }
        }
      }
    });
  }
};
</script>

<style></style>
